module.exports = __webpack_public_path__ + "img/star_2.096278b1.jpg";